/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetUserCouponUsedPageListRespVo } from './GetUserCouponUsedPageListRespVo';
import {
    GetUserCouponUsedPageListRespVoFromJSON,
    GetUserCouponUsedPageListRespVoFromJSONTyped,
    GetUserCouponUsedPageListRespVoToJSON,
    GetUserCouponUsedPageListRespVoToJSONTyped,
} from './GetUserCouponUsedPageListRespVo';

/**
 * 
 * @export
 * @interface PageDataGetUserCouponUsedPageListRespVo
 */
export interface PageDataGetUserCouponUsedPageListRespVo {
    /**
     * 当前页
     * @type {number}
     * @memberof PageDataGetUserCouponUsedPageListRespVo
     */
    currentPage?: number;
    /**
     * 总页数
     * @type {number}
     * @memberof PageDataGetUserCouponUsedPageListRespVo
     */
    totalPage?: number;
    /**
     * 总记录数
     * @type {number}
     * @memberof PageDataGetUserCouponUsedPageListRespVo
     */
    totalRecord?: number;
    /**
     * 列表内容
     * @type {Array<GetUserCouponUsedPageListRespVo>}
     * @memberof PageDataGetUserCouponUsedPageListRespVo
     */
    records?: Array<GetUserCouponUsedPageListRespVo>;
}

/**
 * Check if a given object implements the PageDataGetUserCouponUsedPageListRespVo interface.
 */
export function instanceOfPageDataGetUserCouponUsedPageListRespVo(value: object): value is PageDataGetUserCouponUsedPageListRespVo {
    return true;
}

export function PageDataGetUserCouponUsedPageListRespVoFromJSON(json: any): PageDataGetUserCouponUsedPageListRespVo {
    return PageDataGetUserCouponUsedPageListRespVoFromJSONTyped(json, false);
}

export function PageDataGetUserCouponUsedPageListRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PageDataGetUserCouponUsedPageListRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'currentPage': json['currentPage'] == null ? undefined : json['currentPage'],
        'totalPage': json['totalPage'] == null ? undefined : json['totalPage'],
        'totalRecord': json['totalRecord'] == null ? undefined : json['totalRecord'],
        'records': json['records'] == null ? undefined : ((json['records'] as Array<any>).map(GetUserCouponUsedPageListRespVoFromJSON)),
    };
}

export function PageDataGetUserCouponUsedPageListRespVoToJSON(json: any): PageDataGetUserCouponUsedPageListRespVo {
    return PageDataGetUserCouponUsedPageListRespVoToJSONTyped(json, false);
}

export function PageDataGetUserCouponUsedPageListRespVoToJSONTyped(value?: PageDataGetUserCouponUsedPageListRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'currentPage': value['currentPage'],
        'totalPage': value['totalPage'],
        'totalRecord': value['totalRecord'],
        'records': value['records'] == null ? undefined : ((value['records'] as Array<any>).map(GetUserCouponUsedPageListRespVoToJSON)),
    };
}

